import { render, staticRenderFns } from "./Jurisdiction.vue?vue&type=template&id=512b7fbe&scoped=true&"
import script from "./Jurisdiction.vue?vue&type=script&lang=js&"
export * from "./Jurisdiction.vue?vue&type=script&lang=js&"
import style0 from "./Jurisdiction.vue?vue&type=style&index=0&id=512b7fbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512b7fbe",
  null
  
)

export default component.exports